import { render, staticRenderFns } from "./webLink.vue?vue&type=template&id=70b1c049"
import script from "./webLink.vue?vue&type=script&lang=js"
export * from "./webLink.vue?vue&type=script&lang=js"
import style0 from "./webLink.vue?vue&type=style&index=0&id=70b1c049&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports